import _ from 'lodash';

export const abridgeJobs = jobs => _.reduce(jobs, (abridged, job) => { // eslint-disable-line
  abridged.push({
    title: _.get(job, 'fields.title'),
    slug: _.get(job, 'fields.slug'),
    category: _.get(job, 'fields.category.fields.title'),
  });
  return abridged;
}, []);



// WEBPACK FOOTER //
// ./app/selectors/company/jobs.js